<template>
  <app-card-link-background
    class="group"
    :to="{ name: 'courses-slug', params: { slug: course.slug } }"
  >
    <p class="flex justify-between gap-2 text-balance font-semibold">
      {{ course.title }}
      <app-icon
        class="origin-top-right transition group-hover:scale-110"
        icon="ph:arrow-circle-up-right"
        :size="20"
      />
    </p>

    <div class="mt-2 flex flex-wrap gap-1">
      <course-rating-chip
        v-if="course.ratings"
        size="small"
        :total-number-of-ratings="course.ratings.count"
        :value="course.ratings.avg"
      />
      <course-session-date-chip
        v-if="course.sessions[0]"
        :session="course.sessions[0]"
        size="small"
      />
      <place-address-chip
        v-if="course.sessions[0]?.place"
        :address="course.sessions[0]?.place.address"
        field="city"
        size="small"
      />
    </div>
  </app-card-link-background>
</template>

<script lang="ts" setup>
import type { CourseListView } from "~/business-areas/course/composables/course-list.hook";

defineProps<{
  course: CourseListView;
}>();
</script>
